import React, { useEffect, useState } from "react";
import { Container, Form, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import infoIcon from "../assets/images/infobtnblue.svg";
import verified from "../assets/images/verified.svg";
import TermsandConditionModal from "../Modals/TermsandConditionModal";
import Select from "react-select";
import VerifyEmailModal from "../Modals/VerifyEmailModal";
import { commonservices, TIMEZONE_LIST } from "../services/CommonServices";
import {
  getLoginDataUsingToken,
  SendEmailOtp,
} from "../services/ReduxTookit/Slice/LoginRedux";
import { ProjectTermGetList } from "../services/ReduxTookit/Slice/ProjectTermRedux";
import {
  GetSubscriberProfile,
  UpdateSubscriberProfileAPI,
} from "../services/ReduxTookit/Slice/SubscribersRedux";
import { organizations, userInfo } from "../services/ReduxTookit/UserInfoSlice";
import Loader, { LoaderType } from "./common-component/Loader";
import SubmitLoading from "./common-component/Loaders/SubmitLoading";
import { toast } from "react-toastify";
import MainpageLoader from "./common-component/Loaders/MainpageLoader";
import PhoneInput, {
  formatPhoneNumber,
  formatPhoneNumberIntl,
  isValidPhoneNumber,
  isPossiblePhoneNumber,
} from "react-phone-number-input";
import { Autocomplete } from "@react-google-maps/api";

function CompleteProfile() {
  const navigate = useNavigate();
  const location = useLocation();
  let Userdata = useSelector((state) => state.userinfo.UserInfo);
  // const SignalRKey = useSelector((state) => state?.userinfo?.SignalRKey);

  const OrganizationList = useSelector(
    (state) => state?.userinfo?.Organizations
  );
  let OrgList =
    Array.isArray(OrganizationList) && OrganizationList.length > 0
      ? OrganizationList
      : [];
  const [SortedTimeZone, setSortedTimeZone] = useState([]);
  const [SortedTimeZoneMulti, setSortedTimeZoneMulti] = useState([]);

  let isDeveloperCheck = Userdata?.isdeveloper;
  let DevRoute = window.location.href.includes(`${process.env.REACT_APP_DEV}`);
  const [isEmailValid, setIsEmailValid] = useState(false);
  const handleIsEmailValid = () => {
    setIsEmailValid(true);
  };
  let dispatch = useDispatch();
  const [SubsciberProfileLoader, setSubsciberProfileLoader] = useState(false);
  const [TandCShow, setTandCShow] = useState(false);
  const [isEmailValidate, setisEmailValidate] = useState({
    action: false,
    msg: "This Field is a required field",
  });
  const onLoad = (autoC) => setAutocomplete(autoC);
  const [autocomplete, setAutocomplete] = useState(null);
  const [VerifyModalShow, setVerifyModalShow] = useState(false);
  const [Verifymail, setVerifymail] = useState("");
  const [VerifymailLoader, setVerifymailLoader] = useState(false);
  const [VerifymailText, setVerifymailText] = useState("Verify");

  const [SubmitLoader, setSubmitLoader] = useState(false);
  const [userDataLocal, setUserDataLocal] = useState();

  const [ProjectTermList, setProjectTermList] = useState({
    Preferred_Data_Sources: [],
    Primary_Objective: [],
    Years_of_Experience: [],
    Industry: [],
    Occupation: [],
    Preference_Primary: [],
    Work_Status: [],
  });
  const validateEmail = (email) => {
    const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
    return emailRegex.test(email);
  };
  const [input, setInput] = useState({
    subscriberid: Userdata?.subscriberid,
    email: Userdata?.username,
    isorganization: false,
    companyname: "",
    firstname: "",
    lastname: "",
    contactno1: "",
    dateofbirth: "",
    countryofresidence: "",
    timezone: "",
    city: "",
    address: "",
    address2: "",
    state: "",
    country: "",
    zipcode: "",
    occupation: "",
    industry: "",
    yearsofexperience: "",
    supportemail: "",
    supporthours: "",
    contactno2: "",
    workstatus: "",
    facebooklink: "",
    instagramlink: "",
    linkedinlink: "",
    blogslink: "",
    twitterlink: "",
    // termsandcondition: "",
    // privacypolicy: "",
    subscriberAccountPreferences: [],
    isemailverified: false,
    errors: {
      firstname: "",
      email: "",
      lastname: "",
      contactno1: "",
      supportemail: "",
      countryofresidence: "",
      timezone: "",
      address: "",
      city: "",
      state: "",
      zipcode: "",
      country: "",
      occupation: "",
      industry: "",
      yearsofexperience: "",
      // dateofbirth: "",
      // termsandcondition: "",
      // privacypolicy: "",
      contactno2: "",
      supporthours: "",
      companyname: "",
      ValidationRules: [
        {
          FieldName: "companyname",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "email",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "email",
          ValidationType: "email",
          ValidationMessage: "Invalid email format",
        },
        // {
        //   FieldName: "supporthours",
        //   ValidationType: "required",
        //   ValidationMessage: "This Field is a required field",
        // },
        // {
        //   FieldName: "contactno2",
        //   ValidationType: "required",
        //   ValidationMessage: "This Field is a required field",
        // },
        {
          FieldName: "yearsofexperience",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "industry",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "occupation",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "firstname",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "lastname",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "contactno1",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        // {
        //   FieldName: "supportemail",
        //   ValidationType: "email",
        //   ValidationMessage: "Invalid email format",
        // },
        // {
        //   FieldName: "supportemail",
        //   ValidationType: "required",
        //   ValidationMessage: "This Field is a required field",
        // },
        {
          FieldName: "countryofresidence",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "timezone",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "address",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "city",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "state",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "zipcode",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "country",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        // {
        //   FieldName: "dateofbirth",
        //   ValidationType: "required",
        //   ValidationMessage: "This Field is a required field",
        // },
        // {
        //   FieldName: "termsandcondition",
        //   ValidationType: "required",
        //   ValidationMessage: "This Field is a required field",
        // },
        // {
        //   FieldName: "privacypolicy",
        //   ValidationType: "required",
        //   ValidationMessage: "This Field is a required field",
        // },
      ],
    },
  });
  const onPlaceChanged = () => {
    if (!autocomplete) return;

    const place = autocomplete.getPlace();

    if (!place) return;

    const components: any = {};
    let address2 = "";
    let address = "";

    place.address_components?.forEach((component: any) => {
      const type = component.types[0];

      switch (type) {
        case "locality":
          components.city = component.long_name;
          break;
        case "administrative_area_level_1":
          components.state = component.long_name;
          break;
        case "postal_code":
          components.zipPostal_Code = component.long_name;
          break;
        case "country":
          components.country = component.long_name;
          break;
        case "sublocality_level_1":
        case "sublocality":
        case "neighborhood":
          address2 = component.long_name;
          break;
        case "sublocality_level_2":
          address = component.long_name;
          break;
        default:
          break;
      }
    });

    // const lat = place.geometry?.location?.lat();
    // const lng = place.geometry?.location?.lng();

    setInput({
      ...input,
      address: address || input?.address,
      address2: address2 || "",
      city: components.city || "",
      state: components.state || "",
      zipcode: components.zipPostal_Code || "",
      country: components.country || "",
      // latitude: lat?.toString() || "",
      // longitude: lng?.toString() || "",
      // latitude: parseFloat(lat).toFixed(5),
      // longitude: parseFloat(lng).toFixed(5),
    });
  };
  // const handleCountryChange = (countryCode) => {
  //   fnInputChange(getCountryName(countryCode), "countryofresidence");
  // };
  const checkValidation = (e) => {
    e.preventDefault();
    // if (SignalRKey) {
    //   JSON.parse(SignalRKey)
    //     .stop()
    //     .then(() => {})
    //     .catch((err) => {});
    // }
    let updatedInput = { ...input };
    if (DevRoute && isDeveloperCheck) {
      updatedInput.supportemail = updatedInput.supportemail?.trim();
      updatedInput.supporthours = updatedInput.supporthours?.trim();
      updatedInput.contactno2 = updatedInput.contactno2?.trim();
      updatedInput.errors.supportemail = !updatedInput.supportemail
        ? "Support email is required."
        : !validateEmail(updatedInput.supportemail)
        ? "Invalid email format."
        : "";
      updatedInput.errors.supporthours = !updatedInput.supporthours
        ? "Support hours are required."
        : "";
      updatedInput.errors.contactno2 = !updatedInput.contactno2
        ? "Contact number 2 is required."
        : "";
    }
    if (!updatedInput?.isorganization) {
      updatedInput.companyname = "SQT";
    }
    let validationResult =
      commonservices.fnCheckValidationOfObject(updatedInput);
    setInput({
      ...validationResult.obj,
      errors: {
        ...updatedInput.errors,
        ...validationResult.obj.errors,
      },
    });
    // Check if the form is valid
    if (!isValidForm(validationResult, updatedInput)) {
      return;
    }

    if (Userdata?.isprofilecompleted) {
      HandleSubmit();
    } else {
      setTandCShow(true);
    }
  };

  const isValidForm = (validationResult, updatedInput) => {
    if (!validationResult.isValid) {
      return false;
    }

    if (
      updatedInput.errors.supportemail ||
      updatedInput.errors.supporthours ||
      updatedInput.errors.contactno2
    ) {
      return false;
    }

    if (
      !updatedInput?.isorganization &&
      !validateDateOfBirth(input?.dateofbirth)
    ) {
      return false;
    }

    return true;
  };
  //   const checkValidation = (e) => {
  //     e.preventDefault();
  //     let updatedInput = { ...input };
  //     if (DevRoute && isDeveloperCheck) {
  //       updatedInput.supportemail = updatedInput.supportemail?.trim();
  //       updatedInput.supporthours = updatedInput.supporthours?.trim();
  //       updatedInput.contactno2 = updatedInput.contactno2?.trim();
  //       updatedInput.errors.supportemail = !updatedInput.supportemail
  //         ? "Support email is required."
  //         : !validateEmail(updatedInput.supportemail)
  //         ? "Invalid email format."
  //         : "";
  //       updatedInput.errors.supporthours = !updatedInput.supporthours
  //         ? "Support hours are required."
  //         : "";
  //       updatedInput.errors.contactno2 = !updatedInput.contactno2
  //         ? "Contact number 2 is required."
  //         : "";
  //     }
  //     if (!updatedInput?.isorganization) {
  //       updatedInput.companyname = "SQT";
  //     }
  //     let validationResult =
  //       commonservices.fnCheckValidationOfObject(updatedInput);
  //     setInput({
  //       ...validationResult.obj,
  //       errors: {
  //         ...updatedInput.errors,
  //         ...validationResult.obj.errors,
  //       },
  //     });
  //     // new by prakash
  //     if (!validationResult.isValid) {
  //       return false;
  //     }

  //     if (
  //       updatedInput.errors.supportemail ||
  //       updatedInput.errors.supporthours ||
  //       updatedInput.errors.contactno2
  //     ) {
  //       return false;
  //     }

  //     if (
  //       !input?.isorganization &&
  //       validateDateOfBirth(input?.dateofbirth)
  //     ) {
  //       return false;
  //     }

  //     return true;

  //     setTandCShow(true);

  //     // if (
  //     //   validationResult.isValid &&
  //     //   !updatedInput.errors.supportemail &&
  //     //   !updatedInput.errors.supporthours &&
  //     //   !updatedInput.errors.contactno2 &&
  //     //   validateDateOfBirth(input?.dateofbirth)
  //     // ) {
  //     //   setTandCShow(true);
  //     // }
  //   };

  const getCountryName = (code) => {
    const regionNames = new Intl.DisplayNames(["en"], { type: "region" });
    return code ? regionNames.of(code.toUpperCase()) : "";
  };
  const fnInputChange = (value, tag) => {
    setInput((prevInput) => {
      const updatedInput = {
        ...prevInput,
        [tag]: value || "",
        errors: {
          ...prevInput.errors,
          [tag]: value ? "" : prevInput.errors?.[tag],
        },
      };

      return updatedInput;
    });

    if (tag === "email") {
      const test = validateEmail(value);
      setisEmailValidate((prev) => ({
        ...prev,
        action: false,
        ...(test ? {} : { msg: "Invalid email format" }),
      }));
    }
  };

  async function getProjectTermList() {
    let body = {
      term: "",
      category:
        "Preferred Data Sources,Primary Objective,Years of Experience,Industry,Occupation,Work Status",
    };
    dispatch(ProjectTermGetList(body))?.then((response) => {
      if (response?.payload?.isValidate) {
        if (response?.payload?.data?.data?.length > 0) {
          let updatedArray = [
            ...response?.payload?.data?.data.filter(
              (f) => f.category === "Preferred Data Sources"
            ),
            ...response?.payload?.data?.data.filter(
              (f) => f.category === "Primary Objective"
            ),
          ];
          let temp = [];
          updatedArray?.forEach((element) => {
            temp.push({
              accountpreferenceid: element?.projecttermid,
              term: element?.term,
              categoryname: element?.category,
              isselected: false,
              details: element?.details,
            });
          });
          setProjectTermList({
            Preferred_Data_Sources: response?.payload?.data?.data.filter(
              (f) => f.category === "Preferred Data Sources"
            ),
            Primary_Objective: response?.payload?.data?.data.filter(
              (f) => f.category === "Primary Objective"
            ),
            Years_of_Experience: response?.payload?.data?.data.filter(
              (f) => f.category === "Years of Experience"
            ),
            Industry: response?.payload?.data?.data.filter(
              (f) => f.category === "Industry"
            ),
            Occupation: response?.payload?.data?.data.filter(
              (f) => f.category === "Occupation"
            ),
            Preference_Primary: [
              ...response?.payload?.data?.data.filter(
                (f) => f.category === "Preferred Data Sources"
              ),
              ...response?.payload?.data?.data.filter(
                (f) => f.category === "Primary Objective"
              ),
            ],
            Work_Status: response?.payload?.data?.data.filter(
              (f) => f.category === "Work Status"
            ),
          });
        }
      }
      if (!response?.payload?.isValidate) {
      }
    });
  }
  async function getSubsciberProfile(timezonedata) {
    setSubsciberProfileLoader(true);
    let body = {
      id: Userdata?.subscriberid,
      setSubsciberProfileLoader: setSubsciberProfileLoader,
    };
    dispatch(GetSubscriberProfile(body))?.then((response) => {
      if (response?.payload?.isValidate) {
        if (response?.payload?.data?.data) {
          let basicdata = response?.payload?.data?.data?.dataList1[0];
          setIsEmailValid(validateEmail(basicdata?.email || ""));
          setInput({
            ...input,
            subscriberid: Userdata?.subscriberid,
            isorganization: basicdata?.isorganization,
            firstname: basicdata?.firstname ? basicdata?.firstname : "",
            companyname: basicdata?.companyname ? basicdata?.companyname : "",
            supporthours: basicdata?.supporthours
              ? basicdata?.supporthours
              : "",
            lastname: basicdata?.lastname ? basicdata?.lastname : "",
            contactno1: basicdata?.contactno1 ? basicdata?.contactno1 : "",
            dateofbirth: basicdata?.dateofbirth ? basicdata?.dateofbirth : "",
            countryofresidence: basicdata?.countryofresidence
              ? basicdata?.countryofresidence
              : "",
            // timezone: basicdata?.timezone ? basicdata?.timezone : "",
            timezone: basicdata?.timezone
              ? commonservices.FillMultiSelectValue(
                  basicdata?.timezone,
                  timezonedata
                )
              : "",
            city: basicdata?.city ? basicdata?.city : "",
            address: basicdata?.address ? basicdata?.address : "",
            address2: basicdata?.address2 ? basicdata?.address2 : "",
            state: basicdata?.state ? basicdata?.state : "",
            country: basicdata?.country ? basicdata?.country : "",
            zipcode: basicdata?.zipcode ? basicdata?.zipcode : "",
            occupation: basicdata?.occupation ? basicdata?.occupation : "",
            industry: basicdata?.industry ? basicdata?.industry : "",
            yearsofexperience: basicdata?.yearsofexperience
              ? basicdata?.yearsofexperience
              : "",
            supportemail: basicdata?.supportemail
              ? basicdata?.supportemail
              : "",
            email: basicdata?.email ? basicdata?.email : "",
            contactno2: basicdata?.contactno2 ? basicdata?.contactno2 : "",
            termsandcondition: basicdata?.termsandcondition
              ? basicdata?.termsandcondition
              : "",
            privacypolicy: basicdata?.privacypolicy
              ? basicdata?.privacypolicy
              : "",
            subscriberAccountPreferences:
              response?.payload?.data?.data?.dataList2,
            workstatus: basicdata?.workstatus ? basicdata?.workstatus : "",
            facebooklink: basicdata?.facebooklink
              ? basicdata?.facebooklink
              : "",
            instagramlink: basicdata?.instagramlink
              ? basicdata?.instagramlink
              : "",
            linkedinlink: basicdata?.linkedinlink
              ? basicdata?.linkedinlink
              : "",
            blogslink: basicdata?.blogslink ? basicdata?.blogslink : "",
            twitterlink: basicdata?.twitterlink ? basicdata?.twitterlink : "",
            isemailverified: basicdata?.isemailverified
              ? basicdata?.isemailverified
              : false,
          });
          let proinfo = {
            ...Userdata,
            isorganization:
              response?.payload?.data?.data?.dataList1?.[0]?.isorganization,
            isprofilecompleted:
              response?.payload?.data?.data?.dataList1?.[0]?.isprofilecompleted,
          };
          setUserDataLocal(proinfo);
        }
      }
      if (!response?.payload?.isValidate) {
      }
    });
  }
  async function updateSubscriberProfile() {
    setSubsciberProfileLoader(true);
    let body = {
      id: Userdata?.subscriberid,
      setSubsciberProfileLoader: setSubsciberProfileLoader,
    };
    dispatch(GetSubscriberProfile(body))?.then((response) => {
      if (response?.payload?.isValidate) {
        if (response?.payload?.data?.data) {
          let proinfo = {
            ...Userdata,
            isorganization:
              response?.payload?.data?.data?.dataList1?.[0]?.isorganization,
            isprofilecompleted:
              response?.payload?.data?.data?.dataList1?.[0]?.isprofilecompleted,
          };
          dispatch(userInfo(proinfo));
          if (!location?.pathname?.includes("management-listing")) {
            navigate("/dashboard");
          }
        }
      }
      if (!response?.payload?.isValidate) {
      }
    });
  }

  async function getVerifyOTPemail(mail) {
    setVerifymailLoader(true);
    let body = {
      email: mail,
    };
    dispatch(SendEmailOtp(body)).then((res) => {
      if (res?.payload?.isValidate) {
        setVerifyModalShow(true);
        setVerifymailLoader(false);
      } else {
        setVerifymailLoader(false);
      }
    });

    // ------------- Before redux
    // let resData = await apiCall(
    //   {
    //     method: "POST",
    //     url: API_URL.BASEURL + API_URL.LOGIN.SEND_EMAIL_OTP,
    //     body: body,
    //   },
    //   true
    // );
    // let response = apiResponse(true, resData, setVerifymailLoader);
    // if (response?.isValidate) {
    //   setVerifyModalShow(true);
    // }
    // if (!response?.isValidate) {
    // }
  }
  useEffect(() => {
    getProjectTermList();
  }, []);
  const fnHandleCheckbox = (e, data) => {
    const { checked } = e.target;
    let updatedPreferences = ProjectTermList?.Preference_Primary?.map(
      (item_s) => {
        return {
          accountpreferenceid: item_s.projecttermid,
          categoryname: item_s.category,
          isselected:
            item_s.projecttermid === data?.projecttermid
              ? checked
              : input.subscriberAccountPreferences?.find(
                  (pref) => pref.accountpreferenceid === item_s.projecttermid
                )?.isselected || false,
        };
      }
    );
    setInput({
      ...input,
      subscriberAccountPreferences: updatedPreferences,
    });
  };
  const HandleSubmit = async (e) => {
    setSubmitLoader(true);
    let body = {};
    let formDatabody = {};

    body = {
      subscriberid: Userdata?.subscriberid,
      isorganization: input?.isorganization,
      email: input?.email?.trim(),
      firstname: input?.firstname?.trim(),
      lastname: input?.lastname?.trim(),
      contactno1: input?.contactno1,
      dateofbirth: input?.dateofbirth,
      countryofresidence: input?.countryofresidence,
      // timezone: input?.timezone,
      city: input?.city?.trim(),
      address2: input?.address2?.trim(),
      address: input?.address?.trim(),
      state: input?.state?.trim(),
      country: input?.country?.trim(),
      zipcode: input?.zipcode,
      occupation: input?.occupation,
      industry: input?.industry,
      yearsofexperience: input?.yearsofexperience,
      supportemail: input?.supportemail?.trim(),
      supporthours: input?.supporthours,
      contactno2: input?.contactno2,
      // termsandcondition: input?.termsandcondition,
      // privacypolicy: input?.privacypolicy,
      subscriberAccountPreferences: input.subscriberAccountPreferences,
      workstatus: input?.workstatus,
      facebooklink: input?.facebooklink,
      instagramlink: input?.instagramlink,
      linkedinlink: input?.linkedinlink,
      blogslink: input?.blogslink,
      twitterlink: input?.twitterlink,
    };
    if (input.timezone) {
      body.timezone = input?.timezone?.value;
    }

    if (input.isorganization) {
      formDatabody.companyname = input?.companyname?.trim();
    } else {
      formDatabody.companyname = "";
    }
    for (const [key, value] of Object.entries(body)) {
      if (
        typeof value === "object" &&
        Array.isArray(value) &&
        key !== "componentjson"
      ) {
        value?.map((item, index) => {
          for (const [nestedKey, nestedValue] of Object.entries(item)) {
            formDatabody[`${key}[${index}].${nestedKey}`] = nestedValue;
          }
        });
      } else {
        formDatabody[`${key}`] = value;
      }
    }

    dispatch(UpdateSubscriberProfileAPI(formDatabody))?.then((response) => {
      setSubmitLoader(false);
      if (response?.payload?.isValidate) {
        fnUpdateORG();
        updateSubscriberProfile();
      }
      if (!response?.payload?.isValidate) {
      }
    });
  };
  const fnUpdateORG = () => {
    let body = {
      loginfrom: DevRoute ? "Developer" : "DataFactory",
    };
    dispatch(getLoginDataUsingToken(body))?.then((response) => {
      if (response?.payload?.isValidate) {
        dispatch(organizations(response?.payload?.data?.data?.dataList3));
      }
    });
  };
  const fnVerifyEmailModal = (email) => {
    let test = validateEmail(email);
    if (email) {
      if (test) {
        setisEmailValidate({
          ...isEmailValidate,
          action: false,
        });
        getVerifyOTPemail(email);
        setVerifymail(email);
      } else {
        setisEmailValidate({
          msg: "Invalid email format",
          action: true,
        });
      }
    } else {
      setisEmailValidate({
        msg: "This Field is a required field",
        action: true,
      });
    }
  };
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "Enter" && !VerifyModalShow) {
        event.preventDefault();
        if (!isEmailValid || isEmailValidate.action) {
          const email = document.querySelector("#emailInput")?.value || "";
          fnVerifyEmailModal(email);
        } else {
          checkValidation(event);
        }
      }
    };
    document.addEventListener("keydown", handleKeyPress);
    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, [
    isEmailValid,
    isEmailValidate.action,
    fnVerifyEmailModal,
    checkValidation,
  ]);

  useEffect(() => {
    const sortedTimezones = [...TIMEZONE_LIST].sort((a, b) => {
      const getOffset = (tz) => {
        const sign = tz.includes("+") ? 1 : -1;
        const parts = tz.match(/[\+\-]?\d+:\d+/)[0].split(":");
        return sign * (parseInt(parts[0]) + parseInt(parts[1]) / 60);
      };

      const offsetA = getOffset(a.displayName);
      const offsetB = getOffset(b.displayName);

      return offsetA === offsetB
        ? a.displayName.localeCompare(b.displayName)
        : offsetA - offsetB;
    });
    if (sortedTimezones) {
      let temp = [];
      sortedTimezones.forEach((element) => {
        temp.push({
          label: element?.displayName,
          value: element?.value,
        });
      });
      getSubsciberProfile(temp);
      setSortedTimeZoneMulti(temp);
    }
    setSortedTimeZone(sortedTimezones);
  }, [TIMEZONE_LIST]);
  const validateDateOfBirth = (date) => {
    if (!date) {
      return true;
    }
    // Extract only the YYYY-MM-DD part if the input is in "YYYY-MM-DDTHH:mm:ss" format
    const extractedDate = date.split("T")[0];

    // Regex to validate the YYYY-MM-DD format
    const regex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/;

    if (!regex.test(extractedDate)) {
      setInput({
        ...input,
        errors: {
          ...input.errors,
          ["dateofbirth"]:
            "Invalid date format. Please use the format YYYY-MM-DD.",
        },
      });
      return false;
    }

    const year = parseInt(extractedDate.split("-")[0]);

    if (year < 1900 || year > new Date().getFullYear()) {
      setInput({
        ...input,
        errors: {
          ...input.errors,
          ["dateofbirth"]:
            "Year is not valid. Please enter a year from 1900 to the current year.",
        },
      });
      return false;
    }

    return true;
  };

  return (
    <div className="dashboard-main market-place-page-main market-place-detail-page-main compateline-common account-profile-main">
      {SubmitLoader && <MainpageLoader />}
      <div
        className={
          location?.pathname?.includes("management-listing")
            ? ""
            : "all-page-top complete-profile-page p-0"
        }
      >
        {Userdata?.isprofilecompleted ? (
          <div className="profile-complition-container profile-with-sidebar">
            <div className="top-section-all d-block">
              <div className="top-section-left d-flex align-items-start justify-content-between ">
                <div className="complete-profile-main-title-wrapper">
                  <h2>
                    Complete Your Profile{" "}
                    {!SubsciberProfileLoader && (
                      <>
                        {location?.pathname?.includes("management-listing") && (
                          <span>
                            {" "}
                            {input?.isorganization
                              ? "(Organization)"
                              : "(Individual)"}
                          </span>
                        )}
                      </>
                    )}
                  </h2>

                  <p className="mt-0">
                    Complete your profile to set up your Quantum Datalytica
                    account and get started with your personalized experience.
                  </p>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <Container className="profile-complition-container main-complete-profile-page">
            <div className="top-section-all  p-0 d-block">
              <div className="top-section-left d-flex align-items-start justify-content-between">
                <div className="complete-profile-main-title-wrapper">
                  <h2>
                    Complete Your Profile{" "}
                    {!SubsciberProfileLoader && (
                      <>
                        {location?.pathname?.includes("management-listing") && (
                          <span>
                            {" "}
                            {input?.isorganization
                              ? "(Organization)"
                              : "(Individual)"}
                          </span>
                        )}
                      </>
                    )}
                  </h2>

                  <p className="mb-0">
                    Complete your profile to set up your GitHub account and get
                    started with your personalized experience.
                  </p>
                </div>
              </div>
            </div>
          </Container>
        )}
      </div>
      {SubsciberProfileLoader ? (
        <Loader
          addcss="profilecom"
          type={LoaderType.CompleteProfile}
          count={6}
        />
      ) : (
        <div className="main-page-content compateline-common">
          <Container className="profile-complition-container p-0 ps-1">
            <div className="complete-profile-main-content">
              {!Userdata?.isorganization && (
                <>
                  <div className="select-profile-type">
                    {" "}
                    <h6>Select Account Type</h6>
                    <div className="d-flex align-items-center gap-3 mt-2">
                      <Form.Check
                        type="radio"
                        id="default-radio1"
                        label="Individual"
                        name="output"
                        checked={!input?.isorganization}
                        onChange={(e) =>
                          setInput({
                            ...input,
                            isorganization: false,
                          })
                        }
                      />
                      <Form.Check
                        type="radio"
                        id="default-radio2"
                        label="Organization"
                        name="output"
                        checked={input?.isorganization}
                        onChange={(e) =>
                          setInput({
                            ...input,
                            isorganization: true,
                          })
                        }
                      />
                    </div>
                  </div>
                </>
              )}
              <div
                className={
                  location?.pathname?.includes("management-listing")
                    ? "main-section-for-profile-completion top-header"
                    : "main-section-for-profile-completion"
                }
              >
                <div className="single-section-for-profile-completion">
                  <div className="single-section-for-profile-completion-left">
                    <h3>
                      Basic Information{" "}
                      {input?.isorganization && (
                        <span className="complete-profile-gray-text">
                          (Organization)
                        </span>
                      )}
                    </h3>
                    <p>
                      Please provide your name and essential details to create
                      your profile, ensuring a personalized experience.
                    </p>
                  </div>
                  <div className="single-section-for-profile-completion-right">
                    {input?.isorganization && (
                      <Form.Group className="form-group mb12 w-100">
                        <Form.Label className="common-label">
                          Organization Name
                          <span className="ms-1 red-color-text">*</span>
                        </Form.Label>
                        <div className="position-relative">
                          <Form.Control
                            type="text"
                            placeholder="Organization Name"
                            className="common-input"
                            onChange={(e) =>
                              fnInputChange(e.target.value, "companyname")
                            }
                            maxLength={167}
                            value={input?.companyname}
                            isInvalid={input?.errors?.companyname}
                            disabled={
                              (!input?.isemailverified && !isEmailValid) ||
                              (Userdata?.isorganization &&
                                Userdata?.isprofilecompleted)
                            }
                          />
                          {input.errors.companyname && (
                            <Form.Control.Feedback type="invalid">
                              <span className="error-message-icon">
                                <img
                                  src={infoIcon}
                                  alt="infoIcon"
                                  title={input.errors.companyname}
                                />
                              </span>
                            </Form.Control.Feedback>
                          )}
                        </div>
                      </Form.Group>
                    )}
                    <div className="d-flex gap-2">
                      <Form.Group className="form-group mb12 w-100">
                        <Form.Label className="common-label">
                          {input?.isorganization
                            ? "Contact First Name"
                            : "First Name"}
                          <span className="ms-1 red-color-text">*</span>
                        </Form.Label>
                        <div className="position-relative">
                          <Form.Control
                            type="text"
                            placeholder={
                              input?.isorganization
                                ? "Contact First Name"
                                : "First Name"
                            }
                            className="common-input"
                            onChange={(e) =>
                              fnInputChange(e.target.value, "firstname")
                            }
                            maxLength={67}
                            value={input?.firstname}
                            isInvalid={input?.errors?.firstname}
                            disabled={
                              (!input?.isemailverified && !isEmailValid) ||
                              (!Userdata?.isorganization &&
                                Userdata?.isprofilecompleted)
                            }
                          />
                          {input.errors.firstname && (
                            <Form.Control.Feedback type="invalid">
                              <span className="error-message-icon">
                                <img
                                  src={infoIcon}
                                  alt="infoIcon"
                                  title={input.errors.firstname}
                                />
                              </span>
                            </Form.Control.Feedback>
                          )}
                        </div>
                      </Form.Group>
                      <Form.Group className="form-group mb12  w-100">
                        <Form.Label className="common-label">
                          {input?.isorganization
                            ? "Contact Last Name"
                            : "Last Name"}
                          <span className="ms-1 red-color-text">*</span>
                        </Form.Label>
                        <div className="position-relative ">
                          <Form.Control
                            type="text"
                            placeholder={
                              input?.isorganization
                                ? "Contact Last Name"
                                : "Last Name"
                            }
                            className="common-input"
                            value={input?.lastname}
                            maxLength={67}
                            onChange={(e) =>
                              fnInputChange(e.target.value, "lastname")
                            }
                            isInvalid={input?.errors?.lastname}
                            disabled={
                              (!input?.isemailverified && !isEmailValid) ||
                              (!Userdata?.isorganization &&
                                Userdata?.isprofilecompleted)
                            }
                          />
                          {input.errors.lastname && (
                            <Form.Control.Feedback type="invalid">
                              <span className="error-message-icon">
                                <img
                                  src={infoIcon}
                                  alt="infoIcon"
                                  title={input.errors.lastname}
                                />
                              </span>
                            </Form.Control.Feedback>
                          )}
                        </div>
                      </Form.Group>
                    </div>
                    <Form.Group className="form-group mb12">
                      <Form.Label className="common-label">
                        {input?.isorganization ? "Contact Email" : "Email"}
                        <span className="ms-1 red-color-text">*</span>
                      </Form.Label>

                      <div
                        className={`position-relative d-flex align-items-center gap-2 ${
                          !isEmailValid || isEmailValidate.action
                            ? "d-flex align-items-center gap-2"
                            : ""
                        }`}
                      >
                        {isEmailValid ? (
                          <>
                            <Form.Control
                              type="text"
                              id="emailInput"
                              placeholder="jane.doe@email.com"
                              className="common-input"
                              value={input?.email}
                              onChange={(e) => {
                                fnInputChange(e.target.value, "email");
                                validateEmail(e.target.value || "");
                              }}
                              disabled={input?.isemailverified && isEmailValid}
                            />
                          </>
                        ) : (
                          <Form.Control
                            type="text"
                            id="emailInput"
                            placeholder="jane.doe@email.com"
                            className="common-input"
                            value={input?.email}
                            onChange={(e) => {
                              fnInputChange(e.target.value, "email");
                              validateEmail(e.target.value || "");
                            }}
                            isInvalid={
                              input?.errors?.email || isEmailValidate.action
                            }
                          />
                        )}
                        {input.errors.email ||
                          (isEmailValidate.action && (
                            <Form.Control.Feedback
                              className={
                                isEmailValidate.action ? "feed-class" : ""
                              }
                              type="invalid"
                            >
                              <span className="error-message-icon">
                                <img
                                  src={infoIcon}
                                  alt="infoIcon"
                                  title={isEmailValidate.msg}
                                />
                              </span>
                            </Form.Control.Feedback>
                          ))}
                        {input?.isemailverified && isEmailValid ? (
                          <img
                            src={verified}
                            alt="verified"
                            className="verified-email-icon"
                          />
                        ) : (
                          <>
                            {VerifymailLoader ? (
                              <>
                                {/* <span>Loading</span>{" "} */}
                                <Spinner
                                  // className="ms-1"
                                  animation="border"
                                  role="status"
                                  size="sm"
                                >
                                  <span className="visually-hidden">
                                    {/* Loading... */}
                                  </span>
                                </Spinner>
                              </>
                            ) : (
                              <>
                                {VerifymailText === "success" ? (
                                  <>
                                    <img
                                      src={verified}
                                      alt="verified"
                                      className="verified-email-icon"
                                    />
                                  </>
                                ) : (
                                  <p
                                    onClick={(e) =>
                                      fnVerifyEmailModal(input?.email)
                                    }
                                    className="ps-0 verfy-text"
                                  >
                                    {VerifymailText}
                                  </p>
                                )}
                              </>
                            )}
                          </>
                        )}
                      </div>
                    </Form.Group>
                    <Form.Group className="form-group mb12">
                      <Form.Label className="common-label">
                        Contact Number
                        <span className="ms-1 red-color-text">*</span>
                      </Form.Label>
                      <div className="position-relative">
                        {/* <Form.Control
                          type="text"
                          placeholder="Contact number"
                          className="common-input"
                          value={input?.contactno1}
                          onChange={(e) =>
                            fnInputChange(e.target.value, "contactno1")
                          }
                          maxLength={17}
                          onKeyPress={(event) => {
                            if (!/[0-9]/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                          isInvalid={input?.errors?.contactno1}
                          disabled={!input?.isemailverified && !isEmailValid}
                        /> */}
                        <PhoneInput
                          id="mobileNum"
                          international
                          defaultCountry="US"
                          placeholder="Enter phone number"
                          value={input?.contactno1}
                          maxLength={18}
                          onChange={(value) =>
                            fnInputChange(value, "contactno1")
                          }
                          // onCountryChange={handleCountryChange}
                          inputProps={{
                            name: "phone",
                            required: true,
                          }}
                          className={
                            input.errors.contactno1
                              ? "country-selection error-border"
                              : "country-selection"
                          }
                          title={input.errors.contactno1}
                          disabled={!input?.isemailverified && !isEmailValid}
                        />
                        {input.errors.contactno1 && (
                          <Form.Control.Feedback type="invalid">
                            <span className="error-message-icon">
                              <img
                                src={infoIcon}
                                alt="infoIcon"
                                title={input.errors.contactno1}
                              />
                            </span>
                          </Form.Control.Feedback>
                        )}
                      </div>
                    </Form.Group>
                    <div className="d-flex gap-2">
                      {!input?.isorganization && (
                        <Form.Group className="form-group mb12 w-100">
                          <Form.Label className="common-label">
                            Date of Birth{" "}
                            {/* <span className="complete-profile-gray-text optional-text">
                              (mm-dd-yyyy)
                            </span> */}
                            {/* <span className="ms-1 red-color-text">*</span> */}
                          </Form.Label>
                          {/* <Form.Control
                            type="date"
                            className="common-input"
                            // max={commonservices.getDateInFormatCustom(
                            //   new Date(
                            //     new Date().setFullYear(
                            //       new Date().getFullYear() - 18
                            //     )
                            //   ),
                            //   null,
                            //   "YYYY-MM-DD"
                            // )}
                            max={commonservices.getDateInFormatCustom(
                              new Date(),
                              null,
                              "YYYY-MM-DD"
                            )}
                            value={commonservices.getDateInFormatCustom(
                              input?.dateofbirth,
                              null,
                              "YYYY-MM-DD"
                            )}
                            onChange={(e) =>
                              fnInputChange(e.target.value, "dateofbirth")
                            }
                            disabled={!input?.isemailverified && !isEmailValid}
                          /> */}
                          <div className="position-relative">
                            <Form.Control
                              type="date"
                              className="common-input"
                              max={commonservices.getDateInFormatCustom(
                                new Date(),
                                null,
                                "YYYY-MM-DD"
                              )}
                              value={commonservices.getDateInFormatCustom(
                                input?.dateofbirth,
                                null,
                                "YYYY-MM-DD"
                              )}
                              onChange={(e) => {
                                const inputDate = e.target.value;
                                const currentDate = new Date()
                                  .toISOString()
                                  .split("T")[0];

                                if (inputDate && inputDate > currentDate) {
                                  setInput({
                                    ...input,
                                    errors: {
                                      ...input.errors,
                                      ["dateofbirth"]:
                                        "You cannot select a future date.",
                                    },
                                  });
                                  return;
                                }

                                fnInputChange(inputDate, "dateofbirth");
                              }}
                              disabled={
                                !input?.isemailverified && !isEmailValid
                              }
                              isInvalid={input?.errors?.dateofbirth}
                            />
                            {input.errors.dateofbirth && (
                              <Form.Control.Feedback type="invalid">
                                <span className="error-message-icon">
                                  <img
                                    src={infoIcon}
                                    alt="infoIcon"
                                    title={input.errors.dateofbirth}
                                  />
                                </span>
                              </Form.Control.Feedback>
                            )}
                          </div>
                        </Form.Group>
                      )}

                      <Form.Group className="form-group mb12 w-100">
                        <Form.Label className="common-label">
                          {input?.isorganization
                            ? "Country of Organization"
                            : "Country of Residence"}
                          <span className="ms-1 red-color-text">*</span>
                        </Form.Label>
                        <div className="position-relative">
                          <Form.Control
                            type="text"
                            placeholder={
                              input?.isorganization
                                ? "Country of Organization"
                                : "Country of Residence"
                            }
                            className="common-input"
                            onChange={(e) =>
                              fnInputChange(
                                e.target.value,
                                "countryofresidence"
                              )
                            }
                            maxLength={67}
                            value={input?.countryofresidence}
                            isInvalid={input?.errors?.countryofresidence}
                            disabled={!input?.isemailverified && !isEmailValid}
                          />
                          {input.errors.countryofresidence && (
                            <Form.Control.Feedback type="invalid">
                              <span className="error-message-icon">
                                <img
                                  src={infoIcon}
                                  alt="infoIcon"
                                  title={input.errors.countryofresidence}
                                />
                              </span>
                            </Form.Control.Feedback>
                          )}
                        </div>
                      </Form.Group>
                    </div>
                    <Form.Group className="form-group">
                      {/* <Form.Label className="common-label">
                        Time Zone
                        <span className="ms-1 red-color-text">*</span>
                      </Form.Label>
                      <div className="position-relative">
                        <Form.Select
                          className="common-select"
                          value={input?.timezone}
                          onChange={(e) =>
                            fnInputChange(e.target.value, "timezone")
                          }
                          isInvalid={input?.errors?.timezone}
                          disabled={!input?.isemailverified && !isEmailValid}
                        >
                          <option value="">Select Timezone</option>
                          {SortedTimeZone?.map((item) => {
                            return (
                              <option key={item?.value} value={item?.value}>
                                {item?.displayName}
                              </option>
                            );
                          })}
                        </Form.Select>
                        {input.errors.timezone && (
                          <Form.Control.Feedback type="invalid">
                            <span className="error-message-icon">
                              <img
                                src={infoIcon}
                                alt="infoIcon"
                                title={input.errors.timezone}
                              />
                            </span>
                          </Form.Control.Feedback>
                        )}
                      </div> */}

                      {/* new */}
                      <Form.Group className="form-group">
                        <Form.Label className="common-label">
                          Time Zone
                          <span className="ms-1 red-color-text">*</span>
                        </Form.Label>
                        <div
                          className={` ${
                            input.errors.timezone && "error-border-line"
                          }`}
                        >
                          <div className="position-relative react-select-input">
                            <Select
                              options={SortedTimeZoneMulti}
                              placeholder="Select Timezone"
                              value={input.timezone}
                              onChange={(e) => fnInputChange(e, "timezone")}
                              isDisabled={
                                !input?.isemailverified && !isEmailValid
                              }
                            />
                            {input.errors.timezone && (
                              <span className="error-message-icon">
                                <img
                                  src={infoIcon}
                                  alt="infoIcon"
                                  title={input.errors.timezone}
                                />
                              </span>
                            )}
                          </div>
                        </div>
                      </Form.Group>
                    </Form.Group>
                  </div>
                </div>
                <div className="single-section-for-profile-completion">
                  <div className="single-section-for-profile-completion-left">
                    <h3>
                      Address Information{" "}
                      {input?.isorganization && (
                        <span className="complete-profile-gray-text">
                          (Organization)
                        </span>
                      )}
                    </h3>
                    <p>
                      Enter your current address to help us tailor services and
                      communications to your location for more relevent
                      insights.
                    </p>
                  </div>
                  <div className="single-section-for-profile-completion-right">
                    <Autocomplete
                      onLoad={onLoad}
                      onPlaceChanged={onPlaceChanged}
                    >
                      <Form.Group className="form-group mb12">
                        <Form.Label className="common-label">
                          {input?.isorganization
                            ? "Headquarter Address"
                            : "Street Address"}

                          <span className="ms-1 red-color-text">*</span>
                        </Form.Label>
                        <div className="position-relative">
                          <Form.Control
                            type="text"
                            placeholder={
                              input?.isorganization
                                ? "Headquarter Address"
                                : "Street Address"
                            }
                            className="common-input"
                            value={input?.address}
                            onChange={(e) =>
                              fnInputChange(e.target.value, "address")
                            }
                            maxLength={267}
                            isInvalid={input?.errors?.address}
                            disabled={!input?.isemailverified && !isEmailValid}
                          />
                          {input.errors.address && (
                            <Form.Control.Feedback type="invalid">
                              <span className="error-message-icon">
                                <img
                                  src={infoIcon}
                                  alt="infoIcon"
                                  title={input.errors.address}
                                />
                              </span>
                            </Form.Control.Feedback>
                          )}
                        </div>
                      </Form.Group>
                    </Autocomplete>
                    <Form.Group className="form-group mb12">
                      <Form.Label className="common-label">
                        {input?.isorganization
                          ? "Headquarter Address Line 2 "
                          : "Street Address Line 2 "}
                        <span className="complete-profile-gray-text optional-text">
                          (Optional)
                        </span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder={
                          input?.isorganization
                            ? "Headquarter Address Line 2"
                            : "Street Address Line 2"
                        }
                        className="common-input"
                        value={input?.address2}
                        onChange={(e) =>
                          fnInputChange(e.target.value, "address2")
                        }
                        maxLength={267}
                        disabled={!input?.isemailverified && !isEmailValid}
                      />
                    </Form.Group>
                    <div className="d-flex gap-2">
                      <Form.Group className="form-group mb12 w-100">
                        <Form.Label className="common-label">
                          City<span className="ms-1 red-color-text">*</span>
                        </Form.Label>
                        <div className="position-relative">
                          <Form.Control
                            type="text"
                            placeholder="City"
                            className="common-input"
                            value={input?.city}
                            onChange={(e) =>
                              fnInputChange(e.target.value, "city")
                            }
                            maxLength={67}
                            isInvalid={input?.errors?.city}
                            disabled={!input?.isemailverified && !isEmailValid}
                          />
                          {input.errors.city && (
                            <Form.Control.Feedback type="invalid">
                              <span className="error-message-icon">
                                <img
                                  src={infoIcon}
                                  alt="infoIcon"
                                  title={input.errors.city}
                                />
                              </span>
                            </Form.Control.Feedback>
                          )}
                        </div>
                      </Form.Group>
                      <Form.Group className="form-group mb12 w-100">
                        <Form.Label className="common-label">
                          State<span className="ms-1 red-color-text">*</span>
                        </Form.Label>
                        <div className="position-relative">
                          <Form.Control
                            type="text"
                            placeholder="State"
                            className="common-input"
                            value={input?.state}
                            onChange={(e) =>
                              fnInputChange(e.target.value, "state")
                            }
                            maxLength={67}
                            isInvalid={input?.errors?.state}
                            disabled={!input?.isemailverified && !isEmailValid}
                          />
                          {input.errors.state && (
                            <Form.Control.Feedback type="invalid">
                              <span className="error-message-icon">
                                <img
                                  src={infoIcon}
                                  alt="infoIcon"
                                  title={input.errors.state}
                                />
                              </span>
                            </Form.Control.Feedback>
                          )}
                        </div>
                      </Form.Group>
                    </div>
                    <div className="d-flex gap-2">
                      <Form.Group className="form-group w-100">
                        <Form.Label className="common-label">
                          Zip Code<span className="ms-1 red-color-text">*</span>
                        </Form.Label>
                        <div className="position-relative">
                          <Form.Control
                            type="text"
                            placeholder="Zip code"
                            className="common-input"
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            value={input?.zipcode}
                            onChange={(e) =>
                              fnInputChange(e.target.value, "zipcode")
                            }
                            maxLength={67}
                            isInvalid={input?.errors?.zipcode}
                            disabled={!input?.isemailverified && !isEmailValid}
                          />
                          {input.errors.zipcode && (
                            <Form.Control.Feedback type="invalid">
                              <span className="error-message-icon">
                                <img
                                  src={infoIcon}
                                  alt="infoIcon"
                                  title={input.errors.zipcode}
                                />
                              </span>
                            </Form.Control.Feedback>
                          )}
                        </div>
                      </Form.Group>
                      <Form.Group className="form-group w-100">
                        <Form.Label className="common-label">
                          Country<span className="ms-1 red-color-text">*</span>
                        </Form.Label>
                        <div className="position-relative">
                          <Form.Control
                            type="text"
                            placeholder="Country"
                            className="common-input"
                            value={input?.country}
                            onChange={(e) =>
                              fnInputChange(e.target.value, "country")
                            }
                            maxLength={67}
                            isInvalid={input?.errors?.country}
                            disabled={!input?.isemailverified && !isEmailValid}
                          />
                          {input.errors.country && (
                            <Form.Control.Feedback type="invalid">
                              <span className="error-message-icon">
                                <img
                                  src={infoIcon}
                                  alt="infoIcon"
                                  title={input.errors.country}
                                />
                              </span>
                            </Form.Control.Feedback>
                          )}
                        </div>
                      </Form.Group>
                    </div>
                  </div>
                </div>
                <div className="single-section-for-profile-completion">
                  <div className="single-section-for-profile-completion-left">
                    <h3>Professional Information</h3>
                    <p>
                      Share your job title and industry to help us understand
                      your background and provide tailored resources.
                    </p>
                  </div>
                  <div className="single-section-for-profile-completion-right">
                    <Form.Group className="form-group mb12">
                      <Form.Label className="common-label">
                        {!input?.isorganization
                          ? "Job Title"
                          : "Occupation/Role"}

                        <span className="ms-1 red-color-text">*</span>
                      </Form.Label>
                      <div className="position-relative">
                        <Form.Select
                          className="common-select"
                          value={input?.occupation}
                          onChange={(e) =>
                            fnInputChange(e.target.value, "occupation")
                          }
                          isInvalid={input?.errors?.occupation}
                          disabled={!input?.isemailverified && !isEmailValid}
                        >
                          <option value="">Select occupation</option>
                          {ProjectTermList?.Occupation?.length > 0 &&
                            ProjectTermList?.Occupation?.map((item) => {
                              return (
                                <option key={item?.term} value={item?.term}>
                                  {item?.term}
                                </option>
                              );
                            })}
                        </Form.Select>
                        {input.errors.occupation && (
                          <Form.Control.Feedback type="invalid">
                            <span className="error-message-icon">
                              <img
                                src={infoIcon}
                                alt="infoIcon"
                                title={input.errors.occupation}
                              />
                            </span>
                          </Form.Control.Feedback>
                        )}
                      </div>
                    </Form.Group>
                    <Form.Group className="form-group mb12">
                      <Form.Label className="common-label">
                        Industry<span className="ms-1 red-color-text">*</span>
                      </Form.Label>
                      <div className="position-relative">
                        <Form.Select
                          className="common-select"
                          value={input?.industry}
                          onChange={(e) =>
                            fnInputChange(e.target.value, "industry")
                          }
                          isInvalid={input?.errors?.industry}
                          disabled={!input?.isemailverified && !isEmailValid}
                        >
                          <option value="">Select industry</option>
                          {ProjectTermList?.Industry?.length > 0 &&
                            ProjectTermList?.Industry?.map((item) => {
                              return (
                                <option key={item?.term} value={item?.term}>
                                  {item?.term}
                                </option>
                              );
                            })}
                        </Form.Select>
                        {input.errors.industry && (
                          <Form.Control.Feedback type="invalid">
                            <span className="error-message-icon">
                              <img
                                src={infoIcon}
                                alt="infoIcon"
                                title={input.errors.industry}
                              />
                            </span>
                          </Form.Control.Feedback>
                        )}
                      </div>
                    </Form.Group>
                    <Form.Group className="form-group">
                      <Form.Label className="common-label">
                        Years of Experience
                        <span className="ms-1 red-color-text">*</span>
                      </Form.Label>
                      <div className="position-relative">
                        <Form.Select
                          className="common-select"
                          value={input?.yearsofexperience}
                          onChange={(e) =>
                            fnInputChange(e.target.value, "yearsofexperience")
                          }
                          isInvalid={input?.errors?.yearsofexperience}
                          disabled={!input?.isemailverified && !isEmailValid}
                        >
                          <option value="">Select years of experience</option>
                          {ProjectTermList?.Years_of_Experience?.length > 0 &&
                            ProjectTermList?.Years_of_Experience?.map(
                              (item) => {
                                return (
                                  <option key={item?.term} value={item?.term}>
                                    {item?.term}
                                  </option>
                                );
                              }
                            )}
                        </Form.Select>
                        {input.errors.yearsofexperience && (
                          <Form.Control.Feedback type="invalid">
                            <span className="error-message-icon">
                              <img
                                src={infoIcon}
                                alt="infoIcon"
                                title={input.errors.yearsofexperience}
                              />
                            </span>
                          </Form.Control.Feedback>
                        )}
                      </div>
                    </Form.Group>

                    <Form.Group className="form-group mt-2">
                      <Form.Label className="common-label">
                        Work Status
                      </Form.Label>
                      <div className="position-relative">
                        <Form.Select
                          className="common-select"
                          value={input?.workstatus}
                          onChange={(e) =>
                            fnInputChange(e.target.value, "workstatus")
                          }
                          disabled={!input?.isemailverified && !isEmailValid}
                        >
                          <option value="">Select work status</option>
                          {ProjectTermList?.Work_Status?.length > 0 &&
                            ProjectTermList?.Work_Status?.map((item) => {
                              return (
                                <option key={item?.term} value={item?.term}>
                                  {item?.term}
                                </option>
                              );
                            })}
                        </Form.Select>
                      </div>
                    </Form.Group>
                  </div>
                </div>
                <div className="single-section-for-profile-completion">
                  <div className="single-section-for-profile-completion-left">
                    <h3>Preferred Data Sources</h3>
                    <p>
                      Select your favorite data sources to customize your
                      dashboard and receive insights that match your interests.
                    </p>
                  </div>
                  <div className="single-section-for-profile-completion-right">
                    {ProjectTermList?.Preference_Primary?.length > 0 &&
                      ProjectTermList?.Preference_Primary?.map(
                        (item, index) =>
                          item?.category === "Preferred Data Sources" && (
                            <div className="mb12" key={index}>
                              <Form.Check
                                type="checkbox"
                                id={item?.term}
                                label={item?.term}
                                checked={
                                  input?.subscriberAccountPreferences.find(
                                    (f) =>
                                      parseInt(f.accountpreferenceid) ===
                                        parseInt(item?.projecttermid) &&
                                      f.isselected === true
                                  )
                                    ? true
                                    : false
                                }
                                onClick={(e) => fnHandleCheckbox(e, item)}
                                disabled={
                                  !input?.isemailverified && !isEmailValid
                                }
                              />
                              <p>{item?.details}</p>
                            </div>
                          )
                      )}
                  </div>
                </div>
                <div className="single-section-for-profile-completion">
                  <div className="single-section-for-profile-completion-left">
                    <h3>Primary Objective</h3>
                    <p>
                      Tell us your main goals for using QuantamDataLytica so we
                      can tailor features and resources to meet your needs.
                    </p>
                  </div>
                  <div className="single-section-for-profile-completion-right">
                    {ProjectTermList?.Preference_Primary?.length > 0 &&
                      ProjectTermList?.Preference_Primary?.map(
                        (item, index) =>
                          item?.category === "Primary Objective" && (
                            <div className="mb12" key={index}>
                              <Form.Check
                                type="checkbox"
                                id={item?.term}
                                label={item?.term}
                                checked={
                                  input?.subscriberAccountPreferences.find(
                                    (f) =>
                                      parseInt(f.accountpreferenceid) ===
                                        parseInt(item?.projecttermid) &&
                                      f.isselected === true
                                  )
                                    ? true
                                    : false
                                }
                                onClick={(e) => fnHandleCheckbox(e, item)}
                                disabled={
                                  !input?.isemailverified && !isEmailValid
                                }
                              />
                              <p>{item?.details}</p>
                            </div>
                          )
                      )}
                  </div>
                </div>
                {isDeveloperCheck && DevRoute && (
                  <div className="single-section-for-profile-completion">
                    <div className="single-section-for-profile-completion-left">
                      <h3>Contact & Support</h3>
                      <p>
                        Provide your preferred contact method for timely
                        assistance and updates from our support team.
                      </p>
                    </div>
                    <div className="single-section-for-profile-completion-right">
                      <Form.Group className="form-group mb12">
                        <Form.Label className="common-label">
                          Support Email
                          <span className="ms-1 red-color-text">*</span>
                        </Form.Label>
                        <div className="position-relative">
                          <Form.Control
                            type="mail"
                            placeholder="Support email"
                            className="common-input"
                            value={input?.supportemail}
                            onChange={(e) =>
                              fnInputChange(e.target.value, "supportemail")
                            }
                            maxLength={167}
                            isInvalid={input?.errors?.supportemail}
                            disabled={!input?.isemailverified && !isEmailValid}
                          />
                          {input.errors.supportemail && (
                            <Form.Control.Feedback type="invalid">
                              <span className="error-message-icon">
                                <img
                                  src={infoIcon}
                                  alt="infoIcon"
                                  title={input.errors.supportemail}
                                />
                              </span>
                            </Form.Control.Feedback>
                          )}
                        </div>
                      </Form.Group>
                      <Form.Group className="form-group mb12">
                        <Form.Label className="common-label">
                          Support Hours
                          <span className="ms-1 red-color-text">*</span>
                        </Form.Label>
                        <div className="position-relative">
                          {/* <Form.Control
                            type="text"
                            placeholder="Support hours"
                            className="common-input"
                            value={input?.supporthours}
                            onChange={(e) =>
                              fnInputChange(e.target.value, "supporthours")
                            }
                            maxLength={60}
                  
                            isInvalid={input?.errors?.supporthours}
                            disabled={!input?.isemailverified && !isEmailValid}
                          /> */}
                          <Form.Control
                            type="text"
                            placeholder="Support hours"
                            className="common-input"
                            value={input?.supporthours}
                            onChange={(e) => {
                              // Filter out any non-alphanumeric, space, or hyphen characters
                              const filteredValue = e.target.value.replace(
                                /[^a-zA-Z0-9\s-]/g,
                                ""
                              );
                              fnInputChange(filteredValue, "supporthours");
                            }}
                            maxLength={60}
                            isInvalid={input?.errors?.supporthours}
                            disabled={!input?.isemailverified && !isEmailValid}
                          />
                          {input.errors.supporthours && (
                            <Form.Control.Feedback type="invalid">
                              <span className="error-message-icon">
                                <img
                                  src={infoIcon}
                                  alt="infoIcon"
                                  title={input.errors.supporthours}
                                />
                              </span>
                            </Form.Control.Feedback>
                          )}
                        </div>
                      </Form.Group>
                      <Form.Group className="form-group mb12">
                        <Form.Label className="common-label">
                          Support Contact Number
                          <span className="ms-1 red-color-text">*</span>
                        </Form.Label>
                        <div className="position-relative">
                          {/* <Form.Control
                            type="text"
                            placeholder="Support contact number"
                            className="common-input"
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            value={input?.contactno2}
                            onChange={(e) =>
                              fnInputChange(e.target.value, "contactno2")
                            }
                            maxLength={17}
                            isInvalid={input?.errors?.contactno2}
                            disabled={!input?.isemailverified && !isEmailValid}
                          /> */}
                          <PhoneInput
                            id="mobileNum"
                            international
                            defaultCountry="US"
                            placeholder="Enter phone number"
                            value={input?.contactno2}
                            maxLength={18}
                            onChange={(value) =>
                              fnInputChange(value, "contactno2")
                            }
                            inputProps={{
                              name: "phone",
                              required: true,
                            }}
                            className={
                              input.errors.contactno2
                                ? "country-selection error-border"
                                : "country-selection"
                            }
                            title={input.errors.contactno2}
                            disabled={!input?.isemailverified && !isEmailValid}
                          />
                          {input.errors.contactno2 && (
                            <Form.Control.Feedback type="invalid">
                              <span className="error-message-icon">
                                <img
                                  src={infoIcon}
                                  alt="infoIcon"
                                  title={input.errors.contactno2}
                                />
                              </span>
                            </Form.Control.Feedback>
                          )}
                        </div>
                      </Form.Group>
                      {/* <Form.Group className="form-group mb12">
                        <Form.Label className="common-label">
                          Terms & Conditions
                          <span className="ms-1 red-color-text">*</span>
                        </Form.Label>
                        <div className="position-relative">
                          <div
                            className={`${
                              input.errors.termsandcondition &&
                              "error-border-line"
                            }`}
                          >
                            <CKeditorComponent
                              onChange={handleCKEditor}
                              tag="termsandcondition"
                              value={input?.termsandcondition}
                            />
                            {input.errors.termsandcondition && (
                              <p className="error-line">
                                <span className="error-message-icon">
                                  <img
                                    src={infoIcon}
                                    alt="infoIcon"
                                    title={input.errors.termsandcondition}
                                  />
                                </span>
                              </p>
                            )}
                          </div>
                        </div>
                      </Form.Group>
                      <Form.Group className="form-group mb12">
                        <Form.Label className="common-label">
                          Privacy Policy
                          <span className="ms-1 red-color-text">*</span>
                        </Form.Label>
                        <div className="position-relative">
                          <div
                            className={`${
                              input.errors.privacypolicy && "error-border-line"
                            }`}
                          >
                            <CKeditorComponent
                              onChange={handleCKEditor}
                              tag="privacypolicy"
                              value={input?.privacypolicy}
                            />
                            {input.errors.privacypolicy && (
                              <p className="error-line">
                                <span className="error-message-icon">
                                  <img
                                    src={infoIcon}
                                    alt="infoIcon"
                                    title={input.errors.privacypolicy}
                                  />
                                </span>
                              </p>
                            )}
                          </div>
                        </div>
                      </Form.Group> */}
                    </div>
                  </div>
                )}
                {/* {isDeveloperCheck && DevRoute && ( */}
                <div className="single-section-for-profile-completion">
                  <div className="single-section-for-profile-completion-left">
                    <h3>Social Information</h3>
                    <p>
                      Provide your social plateforms to stay updated and engage
                      with our latest updates and activities.
                    </p>
                  </div>
                  <div className="single-section-for-profile-completion-right">
                    <Form.Group className="form-group mb12">
                      <Form.Label className="common-label">
                        Facebook Link
                      </Form.Label>
                      <div className="position-relative">
                        <Form.Control
                          type="text"
                          placeholder="Facebook Link"
                          className="common-input"
                          value={input?.facebooklink}
                          onChange={(e) =>
                            fnInputChange(e.target.value, "facebooklink")
                          }
                          maxLength={500}
                          disabled={!input?.isemailverified && !isEmailValid}
                        />
                      </div>
                    </Form.Group>
                    <Form.Group className="form-group mb12">
                      <Form.Label className="common-label">
                        Instagram Link
                      </Form.Label>
                      <div className="position-relative">
                        <Form.Control
                          type="text"
                          placeholder="Instagram Link"
                          className="common-input"
                          value={input?.instagramlink}
                          onChange={(e) =>
                            fnInputChange(e.target.value, "instagramlink")
                          }
                          maxLength={500}
                          disabled={!input?.isemailverified && !isEmailValid}
                        />
                      </div>
                    </Form.Group>
                    <Form.Group className="form-group mb12">
                      <Form.Label className="common-label">
                        Linkedin Link
                      </Form.Label>
                      <div className="position-relative">
                        <Form.Control
                          type="text"
                          placeholder="Linkedin Link"
                          className="common-input"
                          value={input?.linkedinlink}
                          onChange={(e) =>
                            fnInputChange(e.target.value, "linkedinlink")
                          }
                          maxLength={500}
                          disabled={!input?.isemailverified && !isEmailValid}
                        />
                      </div>
                    </Form.Group>
                    <Form.Group className="form-group mb12">
                      <Form.Label className="common-label">
                        Blogs Link
                      </Form.Label>
                      <div className="position-relative">
                        <Form.Control
                          type="text"
                          placeholder="Blogs Link"
                          className="common-input"
                          value={input?.blogslink}
                          onChange={(e) =>
                            fnInputChange(e.target.value, "blogslink")
                          }
                          maxLength={500}
                          disabled={!input?.isemailverified && !isEmailValid}
                        />
                      </div>
                    </Form.Group>
                    <Form.Group className="form-group mb12">
                      <Form.Label className="common-label">
                        Twitter Link
                      </Form.Label>
                      <div className="position-relative">
                        <Form.Control
                          type="text"
                          placeholder="Twitter Link"
                          className="common-input"
                          value={input?.twitterlink}
                          onChange={(e) =>
                            fnInputChange(e.target.value, "twitterlink")
                          }
                          maxLength={500}
                          disabled={!input?.isemailverified && !isEmailValid}
                        />
                      </div>
                    </Form.Group>
                  </div>
                </div>
                {input?.isemailverified && isEmailValid && (
                  <div className="d-flex gap-2 justify-content-end">
                    <button
                      disabled={SubmitLoader}
                      className="blue-btn w-auto"
                      onClick={(e) => checkValidation(e)}
                    >
                      {SubmitLoader ? (
                        // <>
                        //   <span>Loading</span>{" "}
                        //   <Spinner
                        //     className="ms-1"
                        //     animation="border"
                        //     role="status"
                        //     size="sm"
                        //   >
                        //     <span className="visually-hidden">Loading...</span>
                        //   </Spinner>
                        // </>
                        <SubmitLoading />
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                )}
              </div>
            </div>
          </Container>
        </div>
      )}
      {VerifyModalShow && (
        <VerifyEmailModal
          show={VerifyModalShow}
          mail={Verifymail}
          verifytext={setVerifymailText}
          handleEmailvalid={handleIsEmailValid}
          bindlist={getSubsciberProfile}
          inputdata={input}
          setinputdata={setInput}
          onHide={() => setVerifyModalShow(false)}
        />
      )}
      {TandCShow && (
        <TermsandConditionModal
          show={TandCShow}
          onsubmit={HandleSubmit}
          loader={SubmitLoader}
          mail={Verifymail}
          // verifytext={setVerifymailText}
          onHide={() => setTandCShow(false)}
        />
      )}
    </div>
  );
}

export default CompleteProfile;
